import { BOAT_RACE_IMAGES } from './boatRacePostUtils';

const GALLERY_IMAGES = {
  heats: BOAT_RACE_IMAGES.heats,
  alleppey: BOAT_RACE_IMAGES.alleppey,
  aranmula: BOAT_RACE_IMAGES.aranmula,
};

/** Upper Kuttanad Water Festival 2026 — timing, boats, teams & live streams (English) */
export const UPPER_KUTTANAD_VALLAM_KALI_ENGLISH_POST = {
  id: 'featured-upper-kuttanad-vallam-kali-english',
  slug: 'upper-kuttanad-vallam-kali-2026-timing-boats-live-stream',
  title: 'Upper Kuttanad Vallam Kali 2026: Race Timing, Boats, Teams & Live Stream',
  excerpt:
    '4th Upper Kuttanad Water Festival on 25 August 2026 — 2:30 PM start on the Pamba River, 1,200 m course, chundan & veppu line-up, and free YouTube live stream links for diaspora fans.',
  publishedAt: '2026-08-23T10:00:00.000Z',
  coverImageUrl: BOAT_RACE_IMAGES.aranmula,
  authorName: 'Daily Sports Life',
  clubName: 'Kerala Sports Desk',
  blogCategory: 'boat-races',
  locale: 'en',
  boatRaceTopic: 'upper-kuttanad-2026',
  alternateSlug: 'upper-kuttanad-vallam-kali-2026-timing-boats-live-stream-malayalam',
  featured: true,
  component: 'WellnessGuideBlogArticle',
  theme: 'diet',
  relatedPostsTitle: 'More Kerala boat race guides',
  relatedPosts: [
    {
      slug: 'upper-kuttanad-vallam-kali-2026-timing-boats-live-stream-malayalam',
      title: 'അപ്പർ കുട്ടനാട് വള്ളംകളി 2026: സമയം, വള്ളങ്ങൾ, ടീമുകൾ & ലൈവ് (മലയാളം)',
      blurb: 'Malayalam edition — same schedule, boat table, and stream links.',
    },
    {
      slug: 'nehru-trophy-2026-chundan-snake-boats-captains',
      title: '72nd Nehru Trophy 2026: 22 Chundan Boats, Clubs & Captains',
      blurb: 'Full NTBR snake-boat line-up three days before Upper Kuttanad.',
    },
    {
      slug: 'kerala-boat-race-live-stream-youtube-channels',
      title: 'Kerala Boat Race Live Stream: Free YouTube Channels',
      blurb: 'Every major Malayalam news desk for vallamkali season.',
    },
    {
      slug: 'thalavady-chundan-history-ntbr-cbl-2026',
      title: 'Thalavady Chundan: History, Victories & NTBR / CBL 2026',
      blurb: 'Upper Kuttanad’s horse-headed snake boat — likely festival entry.',
    },
  ],
  referenceLinks: [
    {
      label: 'Reporter Live — 4th Upper Kuttanad Water Festival announcement',
      url: 'https://www.reporterlive.com/district-news/pathanamthitta/2026/07/16/fourth-upper-kuttanad-water-festival-august-25',
    },
    {
      label: 'Madhyamam — Upper Kuttanad boats at Nehru Trophy',
      url: 'https://www.madhyamam.com/kerala/boats-from-upper-kuttanad-which-participates-nehru-trophy-boat-race-1442442',
    },
    {
      label: 'Kerala Tourism — Veeyapuram Chundan (Capital of Chundans)',
      url: 'https://www.keralatourism.org/champions-boat-league/snake-boats/veeyapuram-chundan',
    },
    {
      label: 'Kerala Tourism — boat races calendar',
      url: 'https://www.keralatourism.org/event/boat-races/',
    },
    {
      label: 'Champions Boat League — Kerala Tourism',
      url: 'https://www.keralatourism.org/champions-boat-league/',
    },
  ],
  sections: [
    {
      type: 'stats',
      ariaLabel: 'Upper Kuttanad Vallam Kali 2026 at a glance',
      items: [
        { value: '25 Aug 2026', label: '4th Upper Kuttanad Water Festival' },
        { value: '2:30 PM IST', label: 'Vallamkali start time' },
        { value: '1,200 m', label: 'Pamba River race course' },
        { value: '25+', label: 'Boats expected (all classes)' },
      ],
    },
    {
      type: 'panel',
      title: 'Capital of chundans — vallamkali on the Pamba',
      paragraphs: [
        'Three days after the **72nd Nehru Trophy** at Punnamada, Kerala’s backwater calendar shifts upstream to **Upper Kuttanad** on the **Pamba River**. The **4th Upper Kuttanad Water Festival** (ജലോത്സവം) lands on **Tuesday, 25 August 2026** — **Uthradam**, the eve of Onam — when villages across Veeyapuram, Niranam, Kadapra, and Mannar gather for their own vallamkali.',
        'Organized by the **Upper Kuttanad Boat Club (UKBC)** with full panchayat cooperation, the regatta runs on a **digitally surveyed 1,200-metre straight course** from **Kadapra Bethlehem St. George Orthodox Church kadavu** to **Kadapra St. Thomas High School kadavu**. Prominent snake boats from across Kerala race alongside local hulls — in **chundan**, **veppu**, **iruttukuthi**, and **churulan** classes.',
        'Veeyapuram panchayat alone fields more than five chundan vallams — locals call it the **“capital of chundans.”** When NTBR lists 22 snake boats, roughly **12 come from Upper Kuttanad villages**. This festival is where those crews sharpen rhythm before the Champions Boat League stretch of the season.',
      ],
      chips: ['Upper Kuttanad', 'Pamba River', 'Uthradam 2026', 'UKBC', 'Vallamkali'],
    },
    {
      type: 'imageGallery',
      title: 'Kerala vallamkali on the backwaters',
      intro: 'Race-day atmosphere on Kerala rivers — Wikimedia Commons (CC BY-SA).',
      images: [
        {
          url: GALLERY_IMAGES.aranmula,
          alt: 'Kerala snake boats racing',
          caption: 'Chundan vallams on Kerala backwaters — Anoopkn / Wikimedia.',
        },
        {
          url: GALLERY_IMAGES.alleppey,
          alt: 'Boat race, Alleppey',
          caption: 'Vallamkali season on the Pamba–Kuttanad network — Wikimedia Commons.',
        },
        {
          url: GALLERY_IMAGES.heats,
          alt: 'Nehru Trophy boat race heats',
          caption: 'The rhythm of a hundred oars — Kuttanad’s heartbeat.',
        },
      ],
    },
    {
      type: 'table',
      title: 'Race-day timing — 25 August 2026 (IST)',
      intro:
        'Official start is **2:30 PM**. Smaller classes typically open the card; chundan finals close the afternoon. Times are approximate — water level and wind on the Pamba can shift the order.',
      headers: ['Time (IST)', 'Event', 'Notes'],
      rows: [
        ['12:00 PM onward', 'Bank-side setup & cultural stage', 'Food stalls, chenda, and vanchippattu rehearsals along Kadapra banks'],
        ['2:00 PM', 'Guest arrival & welcome', 'Dignitaries and panchayat representatives at Upper Kuttanad Water Stadium'],
        ['2:30 PM', 'Formal inauguration & flag-off', 'Vallamkali begins — digital still-start system used from 2026 edition'],
        ['2:45 PM', 'Churulan heats', 'Smallest racing class — warm-up for the crowd'],
        ['3:15 PM', 'Veppu A & Veppu B', 'Traditional cook-boat class — multiple local entries expected'],
        ['3:45 PM', 'Iruttukuthi heats', 'Odi boats — often the most competitive sub-chundan division'],
        ['4:30 PM', 'Chundan heats / finals', 'Headline snake-boat block — prominent Kerala clubs plus Upper Kuttanad hulls'],
        ['5:30 PM onward', 'Prize distribution & cultural programmes', 'Trophy ceremony; Onam-eve celebrations continue into evening'],
      ],
    },
    {
      type: 'panel',
      title: 'Venue & how to reach',
      orderedList: [
        '**Course:** Kadapra Bethlehem St. George Orthodox Church kadavu → Kadapra St. Thomas HSS kadavu (1,200 m)',
        '**Stadium:** Upper Kuttanad Water Stadium on the Pamba River floodplain (Kadapra, Pathanamthitta district)',
        '**Panchayats:** Veeyapuram, Niranam, Kadapra, Mannar — all four cooperate on logistics',
        '**Nearest town:** Thiruvalla (~8 km) — major rail hub on the Ernakulam–Kayamkulam line',
        '**From Alappuzha:** ~45 km by road via Thiruvalla; many spectators combine NTBR weekend with this Uthradam race',
        '**Parking:** Arrive before 1:30 PM — Onam-eve crowds fill the banks early',
      ],
      callout:
        '2026 upgrades: precision still-start, digitally surveyed lanes, expert judging panel, and professional Malayalam commentary (Reporter Live, 16 July 2026).',
    },
    {
      type: 'table',
      title: 'Chundan boats & teams — expected 2026 line-up',
      intro:
        'Organizers have confirmed **chundan**, **veppu**, **iruttukuthi**, and **churulan** entries from leading Kerala clubs **and** local Upper Kuttanad boats. The table below lists **snake boats from the Upper Kuttanad region** that regularly row this festival and NTBR/CBL — confirm final heat sheets with UKBC on race morning. «—» = captain TBC.',
      headers: ['#', 'Chundan boat', 'Boat club / team', 'Home village', 'Notes'],
      rows: [
        ['1', 'Veeyapuram Chundan', 'Village Boat Club, Kainakary', 'Veeyapuram', '2025 Nehru Trophy winner; CBL Season 5 champion — Baiju Kuttanad (capt.)'],
        ['2', 'Karichal Chundan', 'Karichal Chundan Boat Club (KCBC)', 'Karichal / Veeyapuram belt', 'Record 16× Nehru Trophy winner; 2024 NTBR champion'],
        ['3', 'Melpadam Chundan', 'Pallathuruthy Boat Club (PBC)', 'Pallathuruthy', 'Perennial Punnamada finalist; strong Pamba River crew'],
        ['4', 'Thalavady Chundan', 'Kainakari Village Boat Club', 'Thalavady', 'Horse-headed prow — Aaram Thamburan; NTBR 2026 entry'],
        ['5', 'Cheruthana Chundan', 'Thekkekkara Boat Club', 'Cheruthana', 'Payippad & Karuvatta specialist; multiple NTBR finals'],
        ['6', 'Karuvatta Chundan', 'GLC Boat Club / BBM Boat Club', 'Karuvatta', 'Payippad Jalotsavam heritage boat'],
        ['7', 'Karuvatta Sree Vinayakan', 'Mankomb Boat Club', 'Karuvatta', 'Regional trophy regular'],
        ['8', 'Vellamkulangara Chundan', 'SH Boat Club / St. Joseph BC', 'Vellamkulangara', 'Kayalppuram-based snake boat'],
        ['9', 'Payippadan 2 Chundan', 'Payippadan Boat Club', 'Payippad', 'Payippad Neerettupuram Vellipadam Jalotsavam boat'],
        ['10', 'Anari Chundan', 'Kainakari Town Boat Club', 'Anari, Cheruthana', 'Relaunched 2021; major regatta regular'],
        ['11', 'Ayaparambu Pandi Chundan', 'Valiya Divanji BC / KCBC B', 'Ayaparambu', 'Divanji-class rivalries on the Pamba'],
        ['12', 'Sreekarthikeya Sree Ganesh', 'Veeyapuram local club', 'Veeyapuram', 'One of eight chundans registered in Veeyapuram panchayat'],
        ['13', 'Local chundan entries', 'UKBC & village clubs', 'Kadapra / Mannar / Niranam', 'Regional boats — names confirmed on race morning'],
      ],
    },
    {
      type: 'table',
      title: 'Other boat classes — teams & categories',
      intro:
        'Past editions (2nd festival, 2024) drew **25+ racing boats** across all classes. Expect a similar spread in 2026.',
      headers: ['Class', 'Typical entries', 'Example teams / boats'],
      rows: [
        ['Churulan', '2–4', 'Local village clubs — smallest racing hulls'],
        ['Iruttukuthi (Odi)', '8–14', 'Kadapra, Mannar, Niranam village boats; Kuttanad odi specialists'],
        ['Veppu A', '4–6', 'Cook-boat class — Veeyapuram & Kadapra veppu entries'],
        ['Veppu B', '3–5', 'Second veppu division — often the most crowded heat'],
        ['Chundan', '8–12', 'See table above — headline class with NTBR/CBL crews'],
      ],
    },
    {
      type: 'panel',
      title: 'Organizing committee — Upper Kuttanad Boat Club',
      paragraphs: [
        'The **Upper Kuttanad Boat Club (UKBC)** leads festival operations with a 16-member committee drawn from Kadapra, Veeyapuram, Niranam, and Mannar. Leadership from the 2nd edition (2024) includes **James Kuruvila** (president), **Lallu Kattil** (secretary), and **Susan John** (treasurer) — names may be updated for the 4th edition; watch local press on race week.',
        'UKBC’s mission is to keep Upper Kuttanad’s vallamkali tradition alive through transparent judging, equal lane opportunity for every hull, and Onam-season cultural programming that draws visitors to the Pamba banks.',
      ],
      chips: ['UKBC', 'James Kuruvila', 'Kadapra', 'Community-owned'],
    },
    {
      type: 'videoList',
      title: 'Live streaming — watch free on YouTube',
      intro:
        'Regional vallamkali is increasingly streamed on Malayalam news YouTube channels. On **25 August 2026 from ~2:30 PM IST**, open the channels below and search **«അപ്പർ കുട്ടനാട് വള്ളംകളി»** or **«Upper Kuttanad water festival live»**. Coverage varies — start with **Reporter Live** (they broke the 2026 date) and **Asianet News**.',
      videos: [
        {
          title: 'Reporter LIVE',
          channel: 'Reporter TV',
          description:
            'Reporter broke the 4th festival date (16 July 2026) — strong chance of bank-side live feed from Pathanamthitta district.',
          url: 'https://www.youtube.com/@reporterlive',
        },
        {
          title: 'Asianet News Live',
          channel: 'Asianet News',
          description: 'Statewide vallamkali coverage — Veeyapuram/Karuvatta races regularly featured.',
          url: 'https://www.youtube.com/@asianetnews',
        },
        {
          title: 'Manorama News Live',
          channel: 'Manorama News',
          description: 'Onam-week boat race live streams and same-day highlight reels.',
          url: 'https://www.youtube.com/@manoramanews',
        },
        {
          title: '24 News Live',
          channel: 'Twenty Four News',
          description: 'Shaiju Damodaran / Iype Vallikadan commentary on major Kuttanad regattas.',
          url: 'https://www.youtube.com/@24onlive',
        },
        {
          title: 'Mathrubhumi Live',
          channel: 'Mathrubhumi News',
          description: 'Upper Kuttanad flood & festival reporting desk — Pamba region focus.',
          url: 'https://www.youtube.com/@mathrubhuminewslive',
        },
        {
          title: 'MediaOne Live',
          channel: 'MediaOne',
          description: 'Malayalam news — regional jalotsavam windows through Onam season.',
          url: 'https://www.youtube.com/@MediaOneTVLive',
        },
        {
          title: 'Kairali News Live',
          channel: 'Kairali News',
          description: 'Onam-season vallamkali live streams from central Travancore.',
          url: 'https://www.youtube.com/@KairaliNews',
        },
        {
          title: 'Champions Boat League',
          channel: 'CBL — Kerala Tourism',
          description: 'Official CBL channel — highlight packages after league races on the Pamba network.',
          url: 'https://www.youtube.com/@ChampionsBoatLeague',
        },
      ],
    },
    {
      type: 'panel',
      title: 'Streaming tips for diaspora fans',
      list: [
        '**Time zone:** 2:30 PM IST = morning in US East / afternoon in UK — check your local offset for Uthradam Tuesday.',
        '**Search terms:** Try Malayalam tags — «അപ്പർ കുട്ടനാട് ജലോത്സവം ലൈവ്», «കടപ്ര വള്ളംകളി», «UKBC vallamkali».',
        '**Backup plan:** If no dedicated live feed appears by 2:45 PM, watch for highlight clips on Asianet/Manorama within 2–3 hours.',
        '**Mobile data:** YouTube streams are free with ads — no cable subscription needed.',
        '**Follow boats:** Veeyapuram Chundan and Thalavady Chundan post race-day updates on social media.',
      ],
      callout: {
        text: 'Full Kerala streaming channel list →',
        url: '/blog/kerala-boat-race-live-stream-youtube-channels',
      },
    },
    {
      type: 'panel',
      title: 'Why Upper Kuttanad matters in Kerala vallamkali',
      paragraphs: [
        '**Upper Kuttanad** spans the Pamba basin across Alappuzha, Pathanamthitta, and Kottayam districts — villages like **Veeyapuram**, **Thalavady**, **Karuvatta**, **Cheruthana**, **Kadapra**, **Mannar**, and **Niranam**. When Madhyamam counted NTBR entries in 2025, **12 of 19 chundan boats** hailed from this belt.',
        'The **4th Upper Kuttanad Water Festival** is more than a sideshow after Nehru Trophy. It is a community-owned regatta with surveyed lanes, professional commentary, and Onam-eve cultural programming — proof that Kuttanad’s boat-race soul lives as strongly on the Pamba as on Punnamada.',
      ],
      list: [
        '**Veeyapuram** — “capital of chundans”; 8+ snake boats in one panchayat',
        '**Karichal** — most Nehru Trophy wins of any hull in history',
        '**Payippad** — three-day Payippad Neerettupuram Vellipadam Jalotsavam follows Thiruvonam',
        '**CBL 2026** — Upper Kuttanad clubs already tested form at NTBR (22 Aug) and league venues',
      ],
    },
    {
      type: 'panel',
      title: 'In short',
      paragraphs: [
        'Mark **Tuesday, 25 August 2026, 2:30 PM IST** for the **4th Upper Kuttanad Vallam Kali** on the **1,200 m Pamba course** at Kadapra. Expect **25+ boats** across **chundan, veppu, iruttukuthi, and churulan** — starring Upper Kuttanad legends like **Veeyapuram**, **Karichal**, **Melpadam**, and **Thalavady**.',
        'Cannot make the banks? Bookmark **Reporter Live**, **Asianet News**, and **Manorama News** on YouTube and search live at race time. **Good strokes, good rhythm — happy Uthradam!**',
      ],
      chips: ['Upper Kuttanad 2026', 'Pamba', 'Uthradam', 'Live stream', 'Chundan'],
    },
  ],
};
